// Copyright The Linux Foundation and each contributor to LFX.
// SPDX-License-Identifier: MIT

import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { environment } from '@environment';
import { CompanyService } from '@lfx/core/services';
import { MembershipDetails } from '@lfx/key-projects/components/our-membership/our-membership.component';
import { ERROR_MESSAGES } from '@lfx/key-projects/key-projects.constants';

/**
 * API service for membership operations
 * Single Responsibility: Handle membership HTTP operations only
 */
@Injectable({
  providedIn: 'root',
})
export class MembershipService {
  private readonly http = inject(HttpClient);
  private readonly companyService = inject(CompanyService);

  /**
   * Get membership details for a specific project
   */
  getMembershipDetails(projectSlug: string): Observable<MembershipDetails | null> {
    return this.companyService.getMyCompany().pipe(
      switchMap(company => {
        if (!company?.salesforceB2BAccountId) {
          throw new Error(ERROR_MESSAGES.COMPANY_ID_NOT_FOUND);
        }

        const url = `${environment.apiUrl}/memberships/${company.salesforceB2BAccountId}/projects/${projectSlug}/details`;
        return this.http.get<MembershipDetails>(url);
      })
    );
  }
}

